/* ------------------------- External Dependencies -------------------------- */
import React from 'react'
import {
  Box, Flex,
  Button, Container, Heading, Image, Link, Paragraph, Section, Span, SVG,
} from 'atomic'
import {
  FormPersonAddFull
} from 'entity'

/* ------------------------------- Component -------------------------------- */
export default props => 
<Box p={[20,40]}>
  <FormPersonAddFull bg='white' p={[10]} />
</Box>


// WEBPACK FOOTER //
// ./src/interface/entity/Person/PersonCore/PersonAddFull/index.js